<style scoped> 
    .label {
        font-weight: 600;
    }
</style>
<template>
    <div class="form-group">
        <label class="label" for="note">{{ $t('Comments') }}</label>
        <textarea 
            id="note"
            class="form-control" 
            v-model="note" 
            rows="2"
            :disabled="is_view">
        </textarea>
    </div>
</template>
  
<script>
    export default {
        name: 'Comments',
        props: {
            value: {
                type: [String, Number, Object],
                default: null
            },
            is_view : {
                type : Boolean,
                default : false
            }
        },
        computed: {
            note: {
                get() {
                    return this.value;
                },
                set(newValue) {
                    this.$emit('input', newValue);
                }
            }
        }
    }
</script>